import React from 'react';
import Tile from './Tile';

const PageHeaderTile = ({ title, icon: Icon }) => {
  return (
    <Tile className="mb-0 w-full">
      <div className="flex flex-col sm:flex-row sm:items-center p-2 sm:p-4 gap-4">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className="w-12 h-12 rounded-xl bg-tenant-light flex items-center justify-center text-tenant-dark">
              <Icon size={24} strokeWidth={2} />
            </div>
          )}
          <h1 className="text-xl md:text-2xl font-bold text-gray-900">{title}</h1>
        </div>
      </div>
    </Tile>
  );
};

export default PageHeaderTile;
